// @ts-nocheck

import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import RoundedButton from '../../../components/RoundedButton';
import RoundedButtonWithIcon from '../../../components/RoundedButtonWithIcon';
import ScrollShadow from '../../../components/ScrollShadow';
import SpinePlayer from '../../../components/SpinePlayer';
import theme from '../../../styled-components/dark';
import { SpineAnimationIds } from '../../../types/animations';
import { SoundIds } from '../../../types/sounds';
import { KLTutoVideoSvg } from '../assets/svg';
import { KLGlobalStatuses, type KLGlobalStatus } from '../types/global';
import { KLViewTypes } from '../types/view';

import KLViewWrapper from './common/KLViewWrapper';

const sharedMarginStyle = css`
  margin-bottom: 1.3em;
`;

const fadeInAnim = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 65%;
  margin-top: 20%;

  text-align: center;
  opacity: 0;
  font-family: 'BettingArchivoNarrow';

  animation: ${fadeInAnim} 300ms ease-in 3750ms forwards;
`;

const Rules = styled(ScrollShadow)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  margin-bottom: 1em;

  & > * {
    padding: 0 10%;
  }
`;

const Rule = styled.div`
  ${sharedMarginStyle}
`;

const RuleTitle = styled.div`
  font-weight: bold;
  margin-bottom: 0.3em;
`;

const tutoVideoButtonIconStyle = css`
  width: 1.5em;
  height: 1.5em;
  padding-top: 0.1em;
`;

const VideoTutorialButton = styled(RoundedButtonWithIcon)`
  transition: transform 150ms ease-in-out;

  background-color: white;
  color: black;
  margin-bottom: 1em;
`;

const StartButton = styled(RoundedButton)`
  transition: transform 150ms ease-in-out;

  margin-bottom: 1em;
`;

const StyledSpinePlayer = styled(SpinePlayer)`
  height: 100%;
  top: 0;
`;

const SpinePlayerWrapper = styled.div`
  width: 100%;
  padding-top: 120%;
  position: absolute;
  left: 0;
  top: 0;
`;

type KLEnrollmentProps = {
  className?: string;
  onEnroll: () => void;
  onVideoTutorialClick: () => void;
  globalStatus: KLGlobalStatus;
};

const KLEnrollment = ({ className, onEnroll, onVideoTutorialClick, globalStatus }: KLEnrollmentProps) => {
  return (
    <KLViewWrapper className={className} viewType={KLViewTypes.ENROLLMENT}>
      <SpinePlayerWrapper>
        <StyledSpinePlayer animationId={SpineAnimationIds.KL_INTRO} soundId={SoundIds.KL_INTRO} scale={0.67} />
      </SpinePlayerWrapper>
      <InnerWrapper>
        <Rules>
          <Rule>
            <RuleTitle>Commencez l&apos;aventure et gagnez un max de Freebets !</RuleTitle>
          </Rule>
        </Rules>

        <StartButton
          backgroundColor={theme.KLEnrollment.enrollBtnBackgroundColor}
          borderColor={theme.KLEnrollment.enrollBtnBackgroundColor}
          color={theme.KLEnrollment.enrollBtnColor}
          label="Commencer mon aventure"
          disabled={globalStatus === KLGlobalStatuses.ENDING}
          onClick={onEnroll}
        />
        <VideoTutorialButton
          label="Tuto vidéo"
          onClick={onVideoTutorialClick}
          SVGIcon={KLTutoVideoSvg}
          SVGIconStyle={tutoVideoButtonIconStyle}
          iconLeft
        />
      </InnerWrapper>
    </KLViewWrapper>
  );
};

export default KLEnrollment;
